import React from 'react';
import cx from 'classnames';
import PickListItem from '../Item';
import {withPickList} from '../context'
import {noop} from '@ultradent/utilities/Functions';

const PickListSelection = ( {pickList, itemRenderer, className = '', interactionClassName = ''} ) => {
    const {itemType, selectedItem, itemIdProp, groupId, isEditing, actions} = pickList;
    const Component = itemRenderer || PickListItem;
    const isEditable = pickList.isEditable();
    const editAction = isEditable ? actions.toggleEditing : noop;

    return (
        <div data-testid="picklist-selection" className={cx( {hidden: isEditing} )}>
            {selectedItem
                ?
                <div className={cx( className, {[interactionClassName]: isEditable} )}>
                    <Component {...selectedItem} onClick={editAction}/>
                </div>
                :
                <div className={cx( {'button-add-item': isEditable} )} onClick={editAction}>
                    <em className="inline-block">No {itemType} selected</em>
                </div>
            }
            <input id={groupId} name={groupId} type="text"
                   data-testid="picklist-value"
                   className="visually-hidden"
                   defaultValue={selectedItem ? selectedItem[itemIdProp] : ''}
                   required/>
        </div>
    );
};

export default withPickList( PickListSelection )
